import type { TranslateDictionary } from './en.js';

export const Es: TranslateDictionary = {
  'Drop a video file here to upload': 'Arrastra un archivo de video aquí para subir',
  or: 'o',
  'Upload complete!': '¡Subida completada!',
  Retry: 'Reintentar',
  'Pausing...': 'Pausando...',
  Resume: 'Reanudar',
  Pause: 'Pausar',
  'Upload a video': 'Subir un video',
  'No url or endpoint specified - cannot handle upload':
    'No se especificó URL o endpoint - no se puede manejar la subida',
};
